export const SQUARE_CROP_SIZE = 300;
export const HORIZONTAL_CROP_SIZE = 480;
export const FILE_FORMAT = "image/jpeg";
export const FILE_QUALITY = 0.7;
export const FILE_EXTENSION = "jpeg";
export const MAX_RESOLUTION = 1024;
